import * as actions from "./actionTypes";
import { axiosInstance as axios, handleApiError } from "../lib/api";

export const fetchDecisionAids = (projectId, docId, timestamp) => {
  return dispatch => {
    dispatch({ type: actions.FETCHING_DOC });

    return axios
      .get(`/decision-aids/${projectId}/${docId}/${timestamp}`)
      .then(response => {
        dispatch({
          type: actions.FETCHING_DOC_SUCCESS,
          doc: response.data
        });
      })
      .catch(e => {
        dispatch({ type: actions.FETCHING_DOC_FAILED, error: e.response.data });
        handleApiError(e);
      });
  };
};
